/**
 * 헤더 스크롤 동작
 * - 최상단: 표시 + 배경 투명
 * - 스크롤 다운 (100px 이상): 숨김
 * - 스크롤 업: 표시 + 배경 흰색
 * - 다시 최상단: 배경 투명
 */
export function initHeaderScroll(header: HTMLElement): () => void {
  let lastY = window.scrollY;
  let ticking = false;
  const directionThreshold = 8;
  const topThreshold = 10;
  const hideAfterY = 100;

  const applyState = (currentY: number, delta: number) => {
    const atTop = currentY <= topThreshold;
    const forceSolid = header.dataset.headerTheme === 'light';

    if (atTop) {
      header.classList.remove('is-hidden');
      if (forceSolid) {
        header.classList.add('is-solid');
      } else {
        header.classList.remove('is-solid');
      }
      return;
    }

    header.classList.add('is-solid');

    // 50px 이상 내려간 뒤에만 스크롤 다운 시 숨김
    if (currentY >= hideAfterY && delta > directionThreshold) {
      header.classList.add('is-hidden');
    } else if (delta < -directionThreshold) {
      header.classList.remove('is-hidden');
    }
  };

  const update = () => {
    const currentY = window.scrollY;
    const delta = currentY - lastY;
    applyState(currentY, delta);
    lastY = currentY;
    ticking = false;
  };

  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  applyState(window.scrollY, 0);

  return () => {
    window.removeEventListener('scroll', onScroll);
    header.classList.remove('is-hidden', 'is-solid');
  };
}
